import React, { memo } from "react";
import { SiOpenai } from "react-icons/si";
import { NodeCard, valuePill } from "./commonNode";

const accent = "#3498db";

export default memo(({ data, isConnectable, id }) => (
  <NodeCard
    id={id}
    title="OpenAI"
    accent={accent}
    icon={<SiOpenai style={{ width: 14, height: 14, color: accent }} />}
    isConnectable={isConnectable}
    targetTop="50%"
    sourceHandles={[{ id: "a", top: "72%" }]}
  >
    <div style={valuePill(accent)}>
      {data?.name || data?.prompt || "GPT AI Assistant"}
    </div>
  </NodeCard>
));
